var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons16PxDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#111335"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.358 3.03h3.283l-.059-.148c-.063-.154-.27-.293-.438-.293H6.856c-.165 0-.377.142-.438.293l-.06.147zm6.844.588H2.797c-.164 0-.297-.132-.297-.294 0-.163.133-.295.297-.295h2.92l.148-.366c.153-.377.579-.663.99-.663h2.29c.411 0 .836.286.989.663l.149.366h2.92c.164 0 .297.132.297.295 0 .162-.133.294-.298.294zm-7.279 9.265c-.163 0-.296-.127-.302-.285v-.001l-.208-7c0-.079.027-.153.081-.21.054-.058.128-.09.207-.093.15-.006.304.127.307.288l.209 6.997c0 .078-.027.153-.081.21-.054.057-.128.09-.207.094h-.006zm2.077 0c-.165 0-.297-.133-.297-.296V5.59c0-.162.132-.295.297-.295.164 0 .298.133.298.295v6.998c0 .163-.134.296-.298.296zm2.08 0h-.004c-.083-.003-.157-.037-.21-.094-.056-.057-.084-.132-.082-.211l.208-6.999c.006-.158.138-.285.298-.285h.005c.165.005.295.14.292.3l-.209 7.003c-.006.159-.138.286-.297.286zM11.33 14H4.67c-.615 0-1.138-.474-1.164-1.055L3.124 4.36c-.004-.077.024-.15.076-.207.055-.058.13-.092.21-.095.165.015.304.12.31.278L4.1 12.92c.012.272.271.502.569.502h6.66c.297 0 .557-.23.569-.502l.382-8.585c.008-.158.138-.276.297-.276h.01c.081.003.155.035.21.093.053.056.08.13.078.207l-.382 8.586c-.027.58-.55 1.055-1.164 1.055z",
    transform: "translate(-297 -693) translate(0 677) translate(297 16)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons16PxDelete);
export default __webpack_public_path__ + "static/media/icons-16-px-delete.711dcc26af1f4ffc42e945696cb68c14.svg";
export { ForwardRef as ReactComponent };